import { LOCATION_CHANGE } from 'react-router-redux';
import {
    SET_SIZE,
    SET_STICKY_HEADER,
    SET_TRAILER_VISIBLE,
    SET_MOBILE,
} from '../actions/LayoutActions';

const initialState = {
    stickyHeader: false,
    trailerVisible: false,
    mobile: false,
    size: {
        width: window.innerWidth,
        height: window.innerHeight,
        headerHeight: 0,
    },
};

const LayoutReducer = (previousState, action) => {
    const state = {
        ...initialState,
        ...(previousState || null),
    };

    switch (action.type) {
    case SET_STICKY_HEADER:
        return {
            ...state,
            stickyHeader: action.payload,
        };
    case SET_TRAILER_VISIBLE:
        return {
            ...state,
            trailerVisible: action.payload,
        };
    case SET_MOBILE:
        return {
            ...state,
            mobile: action.payload,
        };
    case LOCATION_CHANGE:
        return {
            ...state,
            stickyHeader: false,
            trailerVisible: false,
        };
    case SET_SIZE:
        return {
            ...state,
            size: {
                ...(state.size || null),
                ...(action.payload || null),
            },
        };
    default:
        return state;
    }
};

export default LayoutReducer;



// WEBPACK FOOTER //
// ./js/reducers/LayoutReducer.js